import React, { lazy, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import { toggleVisibility } from '../../utils';
import { checkServiceProvider } from './serviceProviderConfig';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const Import = lazy(() => import(`globalcomponents/UI/Import/${layout}`));
const Modal = require(`globalcomponents/UI/Modal/${layout}`).default;
const Export = lazy(() => import(`globalcomponents/UI/Export/${layout}`));
const SvgIcon = lazy(() => import(`globalcomponents/SvgIcon/${layout}`));

export default function ImportVehicles({ handleImportVehiclePost, callback, handleImportTrailerPost, newUI }) {
  const SERVICE_PROVIDER = window?.$environment?.SERVICE_PROVIDER;
  const i18n = useTranslation();
  const [modal, setModal] = useState(false);

  const resetField = (id) => {
    const fileInput = document.getElementById(id);
    if (fileInput) fileInput.value = '';
  };

  const importVehicles = (file) => {
    handleImportVehiclePost({
      data: file,
      apiId: 'importVehiclePost',
      callback: (type, error, func = () => {}, ers, option) => {
        return callback(type, error, func, ers, option, true);
      },
    });
    setModal(null);
    resetField('fileSelectimportVeh');
  };

  const importTrailers = (file) => {
    handleImportTrailerPost({
      data: file,
      apiId: 'importTrailerPost',
      callback: callback,
    });
    setModal(null);
    resetField('fileSelectimportTra');
  };

  // Modal content for confirmation
  const getModalContent = () => {
    const { id, file } = modal;
    return (
      <div className="deleteParent">
        <div className="imageSection">
          <SvgIcon value={mediaUrls.confirmIcon} alt="Are you sure" />
        </div>
        <h2>{i18n.t('common.insurancePortalWarning')}</h2>
        <div className="deletePopupBtn">
          <div className="cancelBtn">
            <Button
              label={i18n.t('common.ok')}
              type={'reset'}
              onClick={() => {
                setModal(null);
                resetField(id);
              }}
            ></Button>
          </div>
          <div className="deletebtn">
            <Button
              label={i18n.t('common.proceedToImport')}
              onClick={() => {
                setModal(null);
                importTrailers(file);
              }}
            ></Button>
          </div>
        </div>
      </div>
    );
  };

  // Handle import click action logic
  const handleImport = ({ file, id, importAction }) => {
    if (checkServiceProvider('importVehicles_handleImport', SERVICE_PROVIDER, false)) {
      setModal({ id, file });
    } else {
      importAction(file);
    }
  };

  const importVehicle = () => toggleVisibility('ImportVehicles');

  return (
    <>
      {checkServiceProvider('importVehicle_export', SERVICE_PROVIDER) && (
        <Export
          src={layout === 'NewUi' ? mediaUrls.importCircle : mediaUrls.import}
          className="importUserContainer"
          toolTip={i18n.t('common.import')}
          onClick={(e) => importVehicle(e)}
          buttonName={i18n.t('common.import')}
          id="importUserContainer"
          newUI={newUI}
        />
      )}
      <div id="ImportVehicles" className="vehicleModal">
        <ul>
          <li>
            <Import
              onClick={(file) =>
                handleImport({
                  file,
                  id: 'fileSelectimportVeh',
                  importAction: importVehicles,
                })
              }
              asBinary
              importVehicle={i18n.t('vehicles.importVeh')}
              id="importVeh"
            />
          </li>
          <li>
            <Import
              onClick={(file) =>
                handleImport({
                  file,
                  id: 'fileSelectimportTra',
                  importAction: importTrailers,
                })
              }
              asBinary
              importVehicle={i18n.t('vehicles.importTra')}
              id="importTra"
            />
          </li>
        </ul>
      </div>

      {modal && (
        <Modal
          open={true}
          setOpen={setModal}
          data={{
            content: () => getModalContent(),
          }}
          deletePopup
        />
      )}
    </>
  );
}
